/**
 * 基于 https://github.com/DomParfitt/graphviz-react 改造
 *
 * */
import * as React from 'react';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useRef } from 'react';
import { graphviz } from 'd3-graphviz';
import * as d3 from 'd3';
import DraggableScalableContainer from '../../components/draggableContainer';
import { Log } from '@/utils/Log';
let counter = 0;
// eslint-disable-next-line no-plusplus
const getId = () => `graphviz${counter++}`;

// DOT 字符串转义处理函数
const escapeDotString = (dotString) => {
  if (!dotString) return dotString;

  // 使用更宽泛的匹配：从 label=" 开始，匹配到下一个 "属性= 之前的所有内容
  return dotString.replace(/label="(.*?)"([a-zA-Z]+)=/g, (match, labelContent, nextAttr) => {
    // 转义 label 内容中的引号
    const escapedLabel = labelContent.replace(/"/g, '\\"');
    return `label="${escapedLabel}", ${nextAttr}=`;
  });
};

const Graphviz = ({ dot }) => {
  Log.debug('原始 dot:', dot);

  // 对 DOT 字符串进行转义处理
  const escapedDot = useMemo(() => escapeDotString(dot), [dot]);

  Log.debug('转义后 dot:', escapedDot);

  const id = useMemo(getId, []);

  const resetRef = useRef(null);

  const handleReset = () => {
    if (resetRef.current) {
      resetRef.current();
    }
  };

  useEffect(() => {
    handleReset();
    graphviz(`#${id}`)
      .options({
        fit: true,
        height: '100%',
        width: '100%',
        zoom: false,
      })
      .transition(() => {
        d3.transition()
          .delay(200)
          .duration(1000);
      })
      .renderDot(escapedDot);
  }, [escapedDot]);

  return <>
    <div className="h-screen w-full overflow-scroll">
      <DraggableScalableContainer className="w-full h-full" onResetRef={resetRef}>
        <div id={id}>
        </div>
      </DraggableScalableContainer>
    </div>
  </>;
};

Graphviz.propTypes = {
  dot: PropTypes.string,
};

export default Graphviz;
